import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import fp from 'lodash/fp'

class PageTitle extends PureComponent {
  static propTypes = {
    children: PropTypes.string
  }

  render() {
    const title = fp.compose(fp.join(' | '), fp.remove(fp.isUndefined))([
      this.props.children,
      process.env.REACT_APP_TITLE
    ])

    return (
      <Helmet>
        <title>{title}</title>
      </Helmet>
    )
  }
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/PageTitle/PageTitle.js